import React from "react";
import { FunctionComponent } from "react";
import VisitorsList from "./visitors/visitors-list/VisitorsList";
import CreateVisit from "./visitors/create-visit/CreateVisit";
import { Route } from "react-router-dom";

export interface Props {
  isOfficeInitialized: boolean;
}

const AppVisitors: FunctionComponent<Props> = (props: Props) => {
  const { isOfficeInitialized } = props;

  return (
    <>
      <div>
        <Route path="/visitors/visitorsList/:idLocationParam?">
          <VisitorsList></VisitorsList>
        </Route>
        <Route path="/visitors/createVisit/:idLocationParam?">
          <CreateVisit></CreateVisit>
        </Route>
      </div>
    </>
  );
};

export default AppVisitors;
